function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Group_4558",
  "data-name": "Group 4558",
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24"
}, props), /*#__PURE__*/React.createElement("path", {
  id: "Path_2364",
  "data-name": "Path 2364",
  d: "M24 0H0v24h24z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2365",
  "data-name": "Path 2365",
  d: "M10.4 10.667L1.178 4.518a.5.5 0 00-.778.416v14.132a.5.5 0 00.777.416l9.223-6.149v5.733a.5.5 0 00.777.416l10.6-7.066a.5.5 0 000-.832l-10.6-7.066a.5.5 0 00-.777.416z",
  transform: "translate(1.599)",
  fill: "#fff"
})));